export default "assets/images/icons/bus-d1d494a1.svg";